import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
} from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'lyceo-ui-secondary-menu-item',
  templateUrl: './secondary-menu-item.component.html',
  styleUrls: ['./secondary-menu-item.component.scss'],
  imports: [CommonModule, RouterLink, RouterLinkActive],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SecondaryMenuItemComponent {
  public link: InputSignal<undefined | string[]> = input();
}
